import type { FC, PropsWithChildren } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '@stores/auth.store.ts';
import { PathNavigator } from '@utils/path-navigator.ts';

export interface PrivateRouteRedirectState extends Location {}

export const PrivateRoute: FC<PropsWithChildren> = ({ children }) => {
  const location = useLocation();
  const { isLoggedIn } = useAuthStore();

  if (!isLoggedIn) {
    return <Navigate to={PathNavigator.login} replace state={location} />;
  }

  return <>{children}</>;
};
